import reducer from "./EkgReportReducers";

export default reducer;
